import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { EMPTY, Observable, of } from 'rxjs';
import { AgenteOutput } from 'src/app/@shared/models/agente.model';
import { montarQueryString } from '../../base/base.service';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { getErrorMessage } from 'src/app/@shared/helpers/error-message';
import { AlertService } from '../../alert/alert.service';

enum PerfilAcessoTipo {
  ADMINISTRADOR = 1,
  CLIENTE = 2,
  FILIAL = 3,
  AGENTE = 4,
  REGIONAL = 5
}

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class AgenteService {

  constructor(private http: HttpClient, private alertService: AlertService) { }

  
  getAllAgentesPorME(id, req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(`Agente/Manifesto-Embarque/${id}?${req.nome ? `&nome=${req.nome}` : ''}
          ${req.nomeFantasia ? `&nomeFantasia=${req.nomeFantasia}` : ''}
          ${req.uf ? `&uf=${req.uf}` : ''}
          ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
          ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
            { observe: 'response' }
          );
  } 

  selecionarAgentesPorFilial(filialId: number, empresaId: number): Observable<AgenteOutput[]> {
    const filters = {
      filialid: filialId,
      empresaId: empresaId
    }
    return this.http.get<AgenteOutput[]>(`Agente/SelecionarAgentesPorFilial?${montarQueryString(filters)}`, httpOptions);
  }

  selecionarAgentes(): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/SelecionarAgentes`, httpOptions);
  }

  selecionarAgentesPorEmpresa(empresaId): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/SelecionarAgentesPorEmpresa/${empresaId}`, httpOptions);
  }
  selecionarAgentesHub(): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/selecionarAgentesHub`, httpOptions);
  }

  selecionarAgentesHubPorEmpresa(empresaId): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/selecionarAgentesHubPorEmpresa/${empresaId}`, httpOptions);
  }

  selecionarAgentesPorCliente(clienteId): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/SelecionarAgentesPorCliente/${clienteId}`, httpOptions);
  }

  selecionarAgentesPorIds(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Agente/SelecionarAgentesPorIds?${this.getArrayParameterUri(req.regionaisIds, 'RegionaisIds')}`,
        { observe: 'response' }
      );
  }

  selecionarAgentePorResponsavel(agenteId: number): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/Agente?idagente=${agenteId}`, httpOptions);
  }

  consultaAgentes(agenteId?: number): Observable<AgenteOutput[]> {
    return this.http.get<AgenteOutput[]>(`Agente/ConsultaAgentes?idAgente=${agenteId}`, httpOptions);
  }
  
  listarEmpresas(): Observable<any[]> {
    return this.http.get<any[]>(
      `EmpresaXAgente/ConsultaEmpresas`,
      httpOptions
    );
  }
  getArrayParameterUri(parameter, name) {
    let finalSubstring = '';
    if (parameter && parameter.length > 0) {
      parameter.forEach(element => {
        finalSubstring += `${element ? `&${name}=${element}` : ''}`
      });
      return finalSubstring;
    }
    return '';
  }  

  getAgentesRegionalOuTipoAcesso(usuario: any) {
    const request = this.selecionarAgentePorResponsavel(usuario.agenteid)
    .pipe(
      catchError((error) => {
        this.alertService.showError(getErrorMessage(error));
        return EMPTY;
      }),
      switchMap(
        (response) => { 
        if (response.length === 0) {
          switch(usuario.perfilacessotipo){

            case PerfilAcessoTipo.ADMINISTRADOR: 
              return this.selecionarAgentes();

            case PerfilAcessoTipo.AGENTE: 
              return this.selecionarAgentes();

            case PerfilAcessoTipo.FILIAL: 
              return this.selecionarAgentesPorFilial(usuario.filialid, null)
          }
        } else {
          return of(response);
        } return null;
      })
    )
    return request;
  }
}
